module.exports = __webpack_public_path__ + "img/property6.a84207cc.png";